import type { Answers, QuizResult } from './types';
import { emit } from '@/lib/events';

const STORAGE_KEY = 'rm:saved-scenarios:v1';
export const MAX_SCENARIOS = 3;

export interface SavedScenario {
  id: string;
  name: string;
  savedAt: string;
  result: QuizResult;
  answers: Answers;
}

function load(): SavedScenario[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as SavedScenario[]) : [];
  } catch {
    return [];
  }
}

function persist(scenarios: SavedScenario[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scenarios));
  } catch {
    // intentional — error silently ignored
  }
}

export function listScenarios(): SavedScenario[] {
  return load();
}

export function saveScenario(
  name: string,
  result: QuizResult,
  answers: Answers,
): SavedScenario {
  const scenarios = load();
  const entry: SavedScenario = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    name: name.trim() || 'My ranking',
    savedAt: new Date().toISOString(),
    result,
    answers,
  };
  // Keep most recent MAX_SCENARIOS, newest first
  const updated = [entry, ...scenarios].slice(0, MAX_SCENARIOS);
  persist(updated);
  emit('scenario:saved', { total_saved: updated.length });
  return entry;
}

export function deleteScenario(id: string): void {
  persist(load().filter((s) => s.id !== id));
}
